import React from 'react';
import ReactDOM from 'react-dom';
import './assets/stylesheets/index.scss';

import { createMuiTheme } from '@material-ui/core/styles';
import COLORS from 'shared/colors'
import routes from './routes'

import store from 'store/create';
import * as serviceWorker from './serviceWorker';

const theme = createMuiTheme({
    palette: {
        primary: {
            main: COLORS.THEME,
        },
        secondary: {
            main: COLORS.SECONDARY,
        }
    },
});

const App = () => {
    return routes(store, theme)
}

ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
